module.exports = __webpack_public_path__ + "faa07626f2df89af26a4949f8a9e27f7.pdf";